import { render, staticRenderFns } from "./DescriptionFromList.vue?vue&type=template&id=333c23c7&"
import script from "./DescriptionFromList.vue?vue&type=script&lang=js&"
export * from "./DescriptionFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports